import * as z from "zod/v4";

export const getGoogleMerchantCenterOAuthURL = {
  name: "getGoogleMerchantCenterOAuthURL" as const,
  input: z.null(),
  output: z.object({ url: z.string() }),
};
